import { render, staticRenderFns } from "./CoBadge.vue?vue&type=template&id=c9d290d0&scoped=true&"
import script from "./CoBadge.vue?vue&type=script&lang=ts&"
export * from "./CoBadge.vue?vue&type=script&lang=ts&"
import style0 from "./CoBadge.vue?vue&type=style&index=0&id=c9d290d0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d290d0",
  null
  
)

export default component.exports